// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_REQUEST_DK = 'FETCH_COMPACTING_DC_REQUEST_DK';
export const FETCH_COMPACTING_DC_SUCCESS_DK = 'FETCH_COMPACTING_DC_SUCCESS_DK';
export const FETCH_COMPACTING_DC_FAILURE_DK = 'FETCH_COMPACTING_DC_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_STYLE_REQUEST_DK = 'FETCH_COMPACTING_DC_STYLE_REQUEST_DK';
export const FETCH_COMPACTING_DC_STYLE_SUCCESS_DK = 'FETCH_COMPACTING_DC_STYLE_SUCCESS_DK';
export const FETCH_COMPACTING_DC_STYLE_FAILURE_DK = 'FETCH_COMPACTING_DC_STYLE_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_COMPACTING_DC_REQUEST_DK = 'CREATE_COMPACTING_DC_REQUEST_DK';
export const CREATE_COMPACTING_DC_SUCCESS_DK = 'CREATE_COMPACTING_DC_SUCCESS_DK';
export const CREATE_COMPACTING_DC_FAILURE_DK = 'CREATE_COMPACTING_DC_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_DC_DK = 'CREATE_USER_FORM_COMPACTING_DC_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_COMPACTING_DC_REQUEST_DK = 'UPDATE_COMPACTING_DC_REQUEST_DK';
export const UPDATE_COMPACTING_DC_SUCCESS_DK = 'UPDATE_COMPACTING_DC_SUCCESS_DK';
export const UPDATE_COMPACTING_DC_FAILURE_DK = 'UPDATE_COMPACTING_DC_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_COMPACTING_DC_REQUEST_DK = 'FETCH_SINGLE_COMPACTING_DC_REQUEST_DK';
export const FETCH_SINGLE_COMPACTING_DC_SUCCESS_DK = 'FETCH_SINGLE_COMPACTING_DC_SUCCESS_DK';
export const FETCH_SINGLE_COMPACTING_DC_FAILURE_DK = 'FETCH_SINGLE_COMPACTING_DC_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_COMPACTING_DC_REQUEST_DK = 'DELETE_COMPACTING_DC_REQUEST_DK';
export const DELETE_COMPACTING_DC_SUCCESS_DK = 'DELETE_COMPACTING_DC_SUCCESS_DK';
export const DELETE_COMPACTING_DC_FAILURE_DK = 'DELETE_COMPACTING_DC_FAILURE_DK';

// USERFORM RESET

export const COMPACTING_DC_USERFORM_RESET_DK = 'COMPACTING_DC_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_COMPACTING_DC_DETAILS_DK = 'NAVIGATE_COMPACTING_DC_DETAILS_DK';
// navigate to company component
export const NAVIGATE_COMPACTING_DC_DK = 'NAVIGATE_COMPACTING_DC_DK';
export const COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_INVOICE_REQUEST = 'FETCH_COMPACTING_DC_INVOICE_REQUEST';
export const FETCH_COMPACTING_DC_INVOICE_SUCCESS = 'FETCH_COMPACTING_DC_INVOICE_SUCCESS';
export const FETCH_COMPACTING_DC_INVOICE_FAILURE = 'FETCH_COMPACTING_DC_INVOICE_FAILURE';

export const RESET_COMPACTING_DC_INVOICE = 'RESET_COMPACTING_DC_INVOICE';


export const DELETE_BTN_UPDATE_API_REQUEST_DK = 'DELETE_BTN_UPDATE_API_REQUEST_DK';
export const DELETE_BTN_UPDATE_API_SUCCESS_DK = 'DELETE_BTN_UPDATE_API_SUCCESS_DK';
export const DELETE_BTN_UPDATE_API_FAILURE_DK = 'DELETE_BTN_UPDATE_API_FAILURE_DK';